export const UTM_CAMPAIGN_LOCAL_STORAGE = 'utm_campaign';
